// extracted by mini-css-extract-plugin
module.exports = {"container":"teamsTitle__container___2wIlz","draw":"teamsTitle__draw___2l7YP"};